// extracted by mini-css-extract-plugin
module.exports = {"icon":"pill_icon__2Dh1T"};